require '../activerest-m'
require '../translations'
require '../auth'
require '../avatar'
require '../browser_hacks'
require '../browser_location'
require '../tooltip'
require '../shared'
require '../permissions'

require '../logo'
require '../bubblemouth'

require '../legal'
require '../element_viewport_positioning'

require "../svg"



window.base_text =
  fontSize: 24
  fontWeight: 400
  #fontFamily: "arial, 'Avenir Next W01', 'Avenir Next', 'Lucida Grande', 'Helvetica Neue', Helvetica, Verdana, sans-serif"

window.light_base_text = _.extend {}, base_text, 
  fontWeight: 300
          
window.small_text = _.extend {}, base_text,
  fontSize: 20
  fontWeight: if browser.high_density_display then 300 else 400

window.h1 = _.extend {}, base_text,
  fontSize: 42
  fontWeight: 800
  color: 'white'

window.h2 = _.extend {}, base_text,
  fontSize: 36
  fontWeight: 300

window.strong = _.extend {}, base_text,
  fontWeight: 600

window.focus_color = -> 
  customization('focus_color') or focus_blue

window.primary_color = -> c = fetch('colors'); c.primary_color

window.seattle_salmon = '#df6264' #'#ee6061' #'#E16161'


Colors = ReactiveComponent
  displayName: 'Colors'
  render: -> 
    loc = fetch 'location'
    colors = fetch 'colors'
    logo_color = 'white'
    color = seattle_salmon
    switch loc.url 
      when '/'
        # logo_red #'#d65931' #'#B03F3A'
        # '#fff'
        color = seattle_salmon
      when '/tour'
        #'#EC3684'
        #seattle_salmon
        color = '#93B344'
      when '/examples/strategic_planning'          
        color = '#647931'
      when '/examples/decentralized_decisions'          
        color = '#205A83'
      when '/examples', '/examples/public_engagement'          
        color = '#96367E'
      when '/pricing'
        #'#045567'
        color = '#6F3AB0'
        #'#734EA0'
      when '/contact'
        color = '#B03A88'
      when '/create_forum'
        color = '#65B08C'
        #'#348ac7'
        #'#4DBE4D'
        #'#414141'

      when '/metrics'
        color = 'white'
        logo_color = seattle_salmon

    if colors.primary_color != color 
      colors.primary_color = color
      colors.logo_color = logo_color
      save colors 
    SPAN null


require './testimonials'
require './demo'
require './landing_page'
require './examples_page'
require './contact'
require './pricing'
require './customer_signup'
require './metrics'
require './tour'
require './header'
require './footer'



Page = ReactiveComponent

  displayName: "Page"
  mixins: [ AccessControlled ]

  render: ->
    loc = fetch 'location'    
    
    footer_height = fetch('footer').height

    DIV   
      style: 
        backgroundColor: primary_color()        
        transition: 'background-color 500ms ease'
        minHeight: '100%'
        #margin: if footer_height then "0 auto -#{fetch('footer').height}px"

      if loc.query_params.play_demo
        Video
          playing: true 
      else 
        Header()

      if loc.url.indexOf('/examples') > -1
        ExamplesPage()
      else 
        switch loc.url 
          when '/metrics'
            Metrics()
          when '/'
            LandingPage()
          when '/tour'
            Tour()
          when '/pricing'
            Pricing()            
          when '/contact'
            Contact()
          when '/create_forum'
            CustomerSignup()
          when '/privacy_policy'
            PrivacyPolicy()
          when '/terms_of_service'
            TermsOfService()

      Footer()



Computer = ReactiveComponent
  displayName: 'Computer'

  render: -> 
    doc = fetch 'document'

    title = 'Consider.it'
    if doc.title != title
      doc.title = title
      save doc

    SPAN null



window.big_button = -> 
  backgroundColor: primary_color()
  boxShadow: "0 4px 0 0 black"
  fontWeight: 700
  color: 'white'
  padding: '8px 60px'
  display: 'inline-block'
  fontSize: 24
  border: 'none'
  borderRadius: 8


window.BIG_BUTTON = (text, opts) -> 
  opts.style ||= {}
  _.defaults opts.style, big_button()

  BUTTON 
    style: opts.style 
    onClick: opts.onClick
    onKeyPress: (e) -> 
      if e.which == 13 || e.which == 32 # ENTER or SPACE
        e.preventDefault()
        opts.onClick(e)

    text 



Root = ReactiveComponent
  displayName: "Root"

  # Track whether the user is currently swipping. Used to determine whether
  # a touchend event should trigger a click on a link.
  # TODO: I'd like to have this defined at a higher level  
  onTouchMove: -> 
    window.is_swipping = true
  onTouchEnd: -> 
    window.is_swipping = false

  render: ->
    DIV null,
      STYLE 
        dangerouslySetInnerHTML: __html: """
          #content, #content input, #content button, #content textarea {
              font-family: 'Avenir Next W01', 'Avenir Next', 'Lucida Grande', 'Lucida Sans Unicode', 'Helvetica Neue', Helvetica, Verdana, sans-serif;
          }
          """

      BrowserLocation()
      BrowserHacks()

      Page()

      Tooltip
        style: 
          #backgroundColor: primary_color()
          color: 'black'
          maxWidth: 500
          padding: '16px 24px'
      Computer()
      Colors()


window.Saas = Root

require '../bootstrap_loader'



/** WEBPACK FOOTER **
 ** ./@client/product_page/product_page.coffee
 **/